import React from "react";
import styled from "styled-components";
import { Flex, Box } from "grid-styled";
import Button from "../Button";
import * as colors from "../../settings/colors";

const HeaderBox = Box.extend`
  & h1,
  & h2 {
    line-height: 19px;
    font-weight: 500;
  }

  & h1 {
    margin: 0;
    font-size: 16px;
  }

  & h2 {
    color: ${colors.TEXT_SECONDARY};
    font-size: 14px;
    margin: 0 0 8px 0;
  }
`;

const DeleteButton = styled(Button)`@media only print {display: none;}`;

const SectionWrapper = styled(Flex)`
  & + & {
    border-top: 1px solid ${colors.DIVIDER};
  }

  @media only print {
    page-break-inside: avoid;
  }
`;

const FormSection = ({
  className,
  title,
  subtitle,
  children,
  remove,
  ...otherProps
}) => (
  <SectionWrapper wrap="wrap" pt={3} mb={3} {...otherProps}>
    <HeaderBox w={[1, 1, 1 / 3]} pr={1}>
      <h1>{title}</h1>
      <h2>{subtitle}</h2>
      {remove && (
        <DeleteButton type="button" onClick={remove} variant="danger">
          Delete
        </DeleteButton>
      )}
    </HeaderBox>
    <Box w={[1, 1, 2 / 3]}>{children}</Box>
  </SectionWrapper>
);

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/forms/FormSection.js